module.exports = __webpack_public_path__ + "img/normolipidic.b7f96764.jpg";